import { Input, OnChanges, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { clamp } from 'rev-shared/util';
import { WebRtcListenerConnectionService } from 'rev-shared/webrtc/WebRtcListenerConnection.Service';

import { IProducerLayout, IProducerOptions, IScene } from '../../Contract';
import { ProducerService } from '../../Producer.Service';

import mainStyles from '../../ProducerWebcast.module.less';
import styles from './SceneSelector.module.less';

@Component({
	selector: 'scene-selector',
	templateUrl: './SceneSelector.Component.html',
	standalone: false
})
export class SceneSelectorComponent implements OnChanges {
	@Input() public largeScenes: boolean;
	@Input() public producerOptions: IProducerOptions;
	@Input() public scenes: IScene[];

	public shownScenes: IScene[];
	public sceneStartIndex = 0;

	public readonly mainStyles = mainStyles;
	public readonly styles = styles;
	public sceneUsers: string[][];

	constructor(
		private readonly ProducerService: ProducerService,
		private readonly ListenerConnection: WebRtcListenerConnectionService,
		private readonly Translate: TranslateService
	) {}

	public ngOnChanges(): void {
		this.scrollScenes(0);
		this.sceneUsers = this.scenes.map(s => this.getTooltipNames(s.layout));
	}

	public scrollScenes(moveAmount: number): void {
		this.sceneStartIndex += moveAmount;
		this.sceneStartIndex = clamp(this.sceneStartIndex, 0, this.scenes?.length - 1);
		this.shownScenes = this.scenes?.slice(this.sceneStartIndex);
	}

	public select(layout: IProducerLayout): void {
		this.ProducerService.saveProducerSettings({
			...this.producerOptions,
			backstageLayout: layout
		});
	}

	public getTooltipNames(layout: IProducerLayout): string[] {
		const presenters = this.ListenerConnection.presenters.getLayoutPresenters(layout);
		return presenters.map(p => {
			const streams = this.ListenerConnection.presenters.checkPresenterLayout(p.id, layout);
			const str = streams.speaker && streams.content ? 'Event_Producer_CameraAndScreen' :
				streams.speaker ? 'Event_Producer_Camera' :
				streams.content ? 'Event_Producer_Screen' :
				streams.audio ? 'Event_Producer_AudioOnly' : '';
			return `${p.name} - ${this.Translate.instant(str)}`;
		});
	}
}
